import { render, staticRenderFns } from "./Awardreview.vue?vue&type=template&id=64f4aed4&scoped=true"
import script from "./Awardreview.vue?vue&type=script&lang=js"
export * from "./Awardreview.vue?vue&type=script&lang=js"
import style1 from "./Awardreview.vue?vue&type=style&index=1&id=64f4aed4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f4aed4",
  null
  
)

export default component.exports